document.addEventListener( "DOMContentLoaded", () => {
    
    const listContainer = document.querySelector( '#dogs-app .dogs-list' )
    const titleEl       = document.querySelector( '#dogs-app .dog-title' )
    const imageEl       = document.querySelector( '#dogs-app .dog-image' )
    const contentEl     = document.querySelector( '#dogs-app .dog-content' )

    const renderDog = ( dog ) => {

        titleEl.innerHTML   = dog.title.rendered
        contentEl.innerHTML = dog.content.rendered
        const img = dog._embedded?.['wp:featuredmedia']?.[0]?.source_url || ""

        if ( img ) {
            imageEl.src = img
            imageEl.style.display = "block"
        } else {
            imageEl.style.display = "none"
        }

    }

    fetch( "/wp-json/wp/v2/dogs?orderby=date&order=asc&_embed&per_page=100" )
        .then( response => response.json() )
        .then( dogs => {
            if( !dogs.length ) return

            dogs.forEach( ( dog, index ) => {
                const item = document.createElement("button")
                item.textContent = dog.title.rendered
                item.className = "dog-btn"
                item.addEventListener( 'click', () => {
                    renderDog( dog )
                    document.querySelectorAll('#dogs-app .dog-btn').forEach(btn => {
                        btn.classList.remove('active')
                    })
                    item.classList.add('active')
                })
                listContainer.appendChild( item )

                if( index === 0 ) { 
                    renderDog( dog )
                    item.classList.add('active')
                }
            })
        })
})